import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { TradingAccount } from '../../proto/generated/trading-bridge'
import { BrokerId, generateBrokerLoginUrl, getBrokerId, keyValueArrayFromTradingAccountParams } from '../../util/tradingAccounts'
import { isShoonyaBackend } from '../../util/backendProvider'

interface Props {
    primaryTradingAccount: TradingAccount | null
}

export default function ReconnectTradingAccount({ primaryTradingAccount}: Props) {
    const navigate = useNavigate()

    const handleClick = async () => {
        if (!primaryTradingAccount) {
            if (!isShoonyaBackend()) {
                void navigate('/trading-account')
            }
            return
        }
        const { brokerCode } = primaryTradingAccount
        if (brokerCode === BrokerId.DHAN) {
            void navigate(`/trading-account/${brokerCode}`)
        } else {
            const loginUrl = await generateBrokerLoginUrl(getBrokerId(brokerCode), keyValueArrayFromTradingAccountParams())
            void window.open(loginUrl, '_self')
        }
    }

    if (!primaryTradingAccount && isShoonyaBackend()) {
        return null
    }

    return (
        <Button
            sx={{ mt: 2, width: '40%' }}
            variant="contained"
            color="inherit"
            onClick={() => {
                void handleClick()  
            }}
        >
            {primaryTradingAccount? 'Reconnect' : 'Connect'}
        </Button>
    )
}
